import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  async response => {
    if (response.headers['content-type'] && !response.headers['content-type'].startsWith('application/json')) {
      return response
    }
    if (response.headers['content-disposition']) {
      return response
    }
    const result = response.data
    if (result['status'] === 200 || result['code'] === 200 || result['code'] === 0) {
      return result
    } else if (result.status === 401 || result.code === 403) {
      Message.error({
        message: '登录信息失效，请重新登录'
      })
      store.dispatch('user/logout').then(() => {
        setTimeout(() => {
          router.replace('/login')
        }, 1500)
      })
    } else {
      // 如果涉及文件下载responseType blob的情况，将blob对象转化为json
      if (response.config.responseType === 'blob') {
        result.msg = (await fileToJson(response.data)).msg
      }
      Message.error({
        message: result.msg || result.message || '请求出错,请稍候重试'
      })
      return Promise.reject(result.msg || result.message || '请求出错,请稍候重试')
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 将blob对象转化为json（文件类型调用ajax 取后端的返回值做特殊处理）
function fileToJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = res => {
      const { result } = res.target // 得到字符串
      const data = JSON.parse(result) // 解析成json对象
      resolve(data)
    } // 成功回调
    reader.onerror = err => {
      reject(err)
    } // 失败回调
    reader.readAsText(new Blob([file]), 'utf-8') // 按照utf-8编码解析
  })
}
export default service
